import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M72.8474 41.0908C72.8474 41.0908 59.2874 34.2008 55.2374 29.4708C50.7374 24.2108 50.9374 1.5708 50.9374 1.5708H38.5174C38.5174 1.5708 38.8274 24.3208 34.2174 29.4708C29.3274 34.9308 16.6074 40.8908 16.6074 40.8908C22.7974 55.4708 35.1974 59.1908 44.7274 59.1908C54.2574 59.1908 66.6574 55.6808 72.8474 41.0908Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M86.3772 57.9908C84.6472 46.0008 81.1672 42.7408 76.4972 40.3908C73.9872 39.1208 59.4072 31.5508 59.4072 31.5508L54.0572 25.5308L44.7272 30.3908L35.3972 25.5308L30.0472 31.5508C30.0472 31.5508 15.4672 39.1208 12.9572 40.3908C8.28721 42.7408 4.72721 46.3708 3.07721 57.9908C1.37721 69.9108 1.15723 71.8108 1.15723 71.8108H88.3073C88.2972 71.8108 88.1472 70.2408 86.3772 57.9908Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M45.3472 43.5408L48.1971 37.3508L44.7672 31.0708L41.2571 37.3508L44.0972 43.5408L39.8271 70.7508H49.6171L45.3472 43.5408Z"
        fill={secondaryFill}
      />
      <path d="M29.9268 31.5508L39.5168 40.7208L44.5468 30.0808" stroke={outline} strokeMiterlimit="10" fill={fill} />
      <path d="M59.5165 31.5508L49.9365 40.7208L44.8965 30.0808" stroke={outline} strokeMiterlimit="10" fill={fill} />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="44.7238"
          y1="43.5348"
          x2="44.7238"
          y2="4.6713"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
